import React from 'react';
export function SolutionSection() {
  return <section className="py-12 bg-main overflow-hidden" data-id="element-227">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-228">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-229">
          <div data-id="element-230">
            <p className="text-body text-base mb-6 leading-relaxed italic" data-id="element-231">
              Y no: no tienes que "hacerte influencer". Esto es para mujeres que
              quieren un perfil limpio, estético y anónimo… y aun así vender con
              estructura.
            </p>

            <h2 className="text-3xl md:text-5xl font-serif mb-6 leading-tight text-title" data-id="element-232">
              Gana sin ser vista.
            </h2>
            <p className="text-body text-lg mb-4 leading-relaxed" data-id="element-233">
              Las cuentas que más crecen hoy no venden una persona. Venden una
              estética + una solución.
            </p>
            <p className="text-body text-lg mb-8 leading-relaxed" data-id="element-234">
              Sin mostrar tu cara, sin bailar y sin convertir tu vida privada en
              contenido.
            </p>
            <div className="p-6 bg-alt border-l-4 border-accent" data-id="element-235">
              <p className="font-serif text-lg italic text-title" data-id="element-236">
                "La era de vender tu vida privada terminó. Ahora gana quien
                tiene método."
              </p>
              <p className="mt-3 text-sm font-sans text-accent not-italic" data-id="element-237">
                — Método Faceless Spain
              </p>
            </div>

            <div className="mt-8" data-id="element-238">
              <p className="text-sm font-semibold text-title uppercase tracking-widest mb-4" data-id="element-239">
                Cómo funciona (en simple):
              </p>
              <ul className="space-y-3 text-body text-sm" data-id="element-240">
                <li className="flex items-start" data-id="element-241">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-242">
                    1.
                  </span>
                  <span data-id="element-243">Eliges una estética y un ángulo (sin exponerte)</span>
                </li>
                <li className="flex items-start" data-id="element-244">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-245">
                    2.
                  </span>
                  <span data-id="element-246">
                    Publicas contenido faceless con ideas listas (sin quedarte
                    en blanco)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-247">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-248">
                    3.
                  </span>
                  <span data-id="element-249">
                    Monetizas con un sistema claro (sin perseguir gente ni
                    improvisar)
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative" data-id="element-250">
            <div className="space-y-8" data-id="element-251">
              <div className="bg-card p-8 border border-[#E7D8C8] relative" data-id="element-252">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-253">
                  01
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-254">
                  Anonimato que vende
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-255">
                  Construyes una marca que funciona sin depender de tu imagen.
                  Tu privacidad se mantiene intacta.
                </p>
              </div>

              <div className="bg-card p-8 border border-[#E7D8C8] relative ml-4 md:ml-8" data-id="element-256">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-257">
                  02
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-258">
                  Contenido faceless (simple y repetible)
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-259">
                  Aprendes qué formatos funcionan sin rostro y cómo adaptarlos a
                  tu estilo sin complicarte.
                </p>
              </div>

              <div className="bg-card p-8 border border-[#E7D8C8] relative ml-8 md:ml-16" data-id="element-260">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-261">
                  03
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-262">
                  Estructura que convierte
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-263">
                  Perfil, contenido y mensajes alineados para que la gente
                  entienda lo que ofreces y confíe.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}